export default function updateCartViews(data: any) {
    if (Object.prototype.hasOwnProperty.call(data, 'templates')) {
        $.each(data.templates, (templateName, templateHtml) => {
            // @ts-ignore
            const $element = $(`[data-cart-template="${templateName}"]`, 'body');

            if ($element.length) {
                $element.children().remove();
                $element.append(templateHtml);

                if ($('.undeliverableAddress').length) {
                    (window as any).Swal({
                        type: 'error',
                        title: '',
                        html: true,
                        text: $('.undeliverableAddress').html(),
                    });
                }
            } else if (templateName === 'cart-popup') {
                toastr.success(templateHtml);
            } else if (templateName === 'cart-popup-html') {
                $(`[data-append-template="${templateName}"]`)
                    .empty()
                    .append(templateHtml);
            }
        });
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));

        // @ts-ignore Faux positif, bootstrap est bien connu ici
        tooltipTriggerList.map((tooltipTriggerEl: any) => new bootstrap.Tooltip(tooltipTriggerEl));
    }
    // Si la requète dispose de données pour la datalayer GTM et que la classe
    // JS de GTM est chargée alors on les transferts
    // console.log('before dataLayer.push(data.gtm[k]);');
    // @ts-ignore
    if (typeof dataLayer !== 'undefined' && data.gtm !== undefined) {
        (window as any).dataLayer.push(data.gtm);

        // // Envoi des données à GTM
        // Object.keys(data.gtm).forEach((k) => {
        //     // console.log('dataLayer.push(data.gtm[k]);');
        //     (window as any).dataLayer.push(data.gtm[k]);
        // });
    }

    if (typeof _mtm !== 'undefined' && data.mtm !== undefined) {
        // Envoi des données à GTM
        Object.keys(data.mtm).forEach((k) => {
            (window as any)._mtm.push(data.mtm[k]);
        });
    }
}
